import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    0% { opacity: 0; transform: ", "; }\n    100% { opacity: 1; transform: translate3d(0, 0, 0); }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n      0% { opacity: 0; }\n      100% { opacity: 1; }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { keyframes } from '@emotion/react';
export var generateKeyframes = function generateKeyframes(from, offset) {
  if (from === 'center') {
    return keyframes(_templateObject());
  }

  var initialTransformValue;

  switch (from) {
    case 'right':
      initialTransformValue = "translate3d(" + offset + "px, 0, 0)";
      break;

    case 'left':
      initialTransformValue = "translate3d(-" + offset + "px, 0, 0)";
      break;

    case 'top':
      initialTransformValue = "translate3d(0, -" + offset + "px, 0)";
      break;

    case 'bottom':
    default:
      initialTransformValue = "translate3d(0, " + offset + "px, 0)";
  }

  return keyframes(_templateObject2(), initialTransformValue);
};